export interface MerchCategoryDto {
  id: string
  merchId: string
  name: string
  status: number
  isDel: number
  sort: number
}

export interface GetMerchFoodCategoriesRespone {
  result: MerchCategoryDto[]
}

export interface scheduleFood {
  foodId: string
  expirationTime: string | Date
}

export interface MerchFoodForBusinessDto {
  id: string
  merchId: string
  name: string
  categoryIds: string[]
  stock: number
  price: number
  status: number
  banner: string
  tax: number
  like: number
  sort: number
  labels: string[]
}

export const MerchFoodForBusiness: MerchFoodForBusinessDto = {
  id: '',
  merchId: '',
  name: '',
  categoryIds: [],
  stock: 0,
  price: 0,
  status: 0,
  banner: '',
  tax: 0,
  like: 0,
  sort: 0,
  labels: []
}

export enum MerchFoodStatus {
  OffSale,
  OnSale
}

export enum MerchFoodOutOfStock {
  OutOfStock,
  Stock
}

export enum TabIndex {
  All,
  OutOfStock,
  Unavailable,
  Sales
}
